import { render, staticRenderFns } from "./Edit.bundle-ids.vue?vue&type=template&id=63da59f2&scoped=true&"
import script from "./Edit.bundle-ids.vue?vue&type=script&lang=js&"
export * from "./Edit.bundle-ids.vue?vue&type=script&lang=js&"
import style0 from "./Edit.bundle-ids.vue?vue&type=style&index=0&id=63da59f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da59f2",
  null
  
)

export default component.exports